import {Localization} from '@hconnect/uikit'

const props = {
  backend: {
    loader: (filename) => {
      if (process.env.NODE_ENV === 'development') {
        console.info(`Load Translation for legal [${filename}]`)
      }
      return import(`./${filename}.json`).catch((err) => {
        if (process.env.NODE_ENV === 'development') {
          console.error(`Could not load Translation for legal [${filename}]`)
        }
        return {err}
      })
    }
  }
}

export default () => Localization(props)
